import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { Avatar } from '@material-ui/core';
import { CMSHelper } from '../../../../../../Helpers/CMSHelper';
import { CMSRevisionModel } from '../../../../../../Models/CMSRevisionModel';
import { CMSMetaModel } from '../../../../../../Models/CMSMetaModel';

import "./BlogView.scss";
import { SnackbarManager } from '../../../../../../Helpers/SnackbarManager/SnackbarManager';
import { CourseHelper } from '../../../../../../Helpers/CourseHelper';
import { CourseOrganizerHelper } from '../../../../../../Helpers/CourseOrganizerHelper';
import { CoursePartnerModel } from '../../../../../../Models/CoursePartnerModel';
import { getLanguage } from '../../../../../../Helpers/LanguageHelper';

interface IProps extends RouteComponentProps {

}

export function CourseView(props: IProps) {
  let cmsHelper = new CMSHelper();
  let courseHelper = new CourseHelper();
  let courseOrganizerHelper = new CourseOrganizerHelper();

  const [body, setBody] = useState<CMSRevisionModel>();
  const [meta, setMeta] = useState<CMSMetaModel>();
  const [publishDate, setPublishDate] = useState('');
  const [coursePartner, setCoursePartner] = useState<CoursePartnerModel>();

  useEffect(() => {
    preparePage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function preparePage() {
    let pathName = window.location.pathname.replace('/course/', '');
    let id = pathName.split('/')[0];

    if (id != null) {
      fetchData(id);
    } else {
      SnackbarManager.Instance.addError('could not load the blogpost')
    }
  }


  function scrollToTopFunction() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  async function fetchData(id: string) {
    scrollToTopFunction();

    let post = await cmsHelper.getContentByPId(id);

    compareUrl(post);

    if (post == null) {
      return SnackbarManager.Instance.addError('could not load data from server');
    } else if (post && post.isPublished === false) { //FIXME: does isPublished even exist?
      return props.history.push('/404');
    }
    let coursePartner = await courseOrganizerHelper.getCoursePartnerByCmsMetaId(post.Id);
    if (!coursePartner) {
      SnackbarManager.Instance.addError(getLanguage(469, 'unkown error'));
      return;
    }

    setCoursePartner(coursePartner);

    let date = 'blogpost is not published';
    if (post.PrimaryRevision != null && post.PrimaryRevision !== '') {
      let revision = new CMSMetaModel(post).getPrimaryRevision();
      if (revision) {
        date = revision.Created.toString();
        setBody(revision);
        setMeta(post);
        setPublishDate(date);
      }
    } else {
      let rev = new CMSMetaModel(post).getNewestRevision();
      if (!rev) return null;
      setBody(rev);
      setMeta(post);
      setPublishDate(date);
    }
  }

  function compareUrl(post: CMSMetaModel | null) {
    //@ts-ignore
    if (!post || (props.location.state && props.location.state.redirected === true)) { return }

    let url = '/course/' + post.PublicId + '/' + post.Title.toLowerCase();
    let actualUrl = props.location.pathname;

    if (url !== actualUrl) {
      props.history.push(url, { redirected: true });
    }
  }

  function headerImage() {
    if (!body || !body.CoverImageUrl || body.CoverImageUrl === '') {
      return (<div className="blogHeaderImage">
        <div className="blogHeaderImage_placeholder">
          <div className="blogHeaderImage_placeholder_text">
          </div>
        </div>
      </div>)
    }
    let divStyle = {
      color: 'white',
      backgroundImage: 'url(' + body.CoverImageUrl + ')',
      WebkitTransition: 'all', // note the capital 'W' here
      msTransition: 'all' // 'ms' is the only lowercase vendor prefix
    };

    return (<div className="blogHeaderImage" style={divStyle}> </div>)
  }

  function getCoursePartner() {
    let authorImg = '';
    let authorName = '';

    if (coursePartner) {
      // authorImg
      authorName = coursePartner.Name;
    }

    return (
      <div className="authorInfo">
        <Avatar className="authorImage" src={authorImg} />
        <div className="nameAndDate">
          <p>{authorName}</p>
          <h6>{publishDate}</h6>
        </div>
      </div>
    );
  }


  return (
    <div className="blogPost_view">
      {headerImage()}
      <div className="blogWrapper">
        <div className="blogContent">
          <div className="blogHeader">
            <h1 className="displayFont">{meta && meta.Title}</h1>
            {getCoursePartner()}
          </div>
          <div className="blogText">
            <div dangerouslySetInnerHTML={{ __html: body != null ? body.Text : '' }} />
          </div>
        </div>
      </div>
    </div>
  )
}

